import { Box, createStyles } from '@mantine/core';
import { SettingsSelect } from '@repo/common/components/SettingsSelect';
import { Title } from '@repo/foundations';
import { useCallback } from 'react';
import { useAuthUser, useUpdateUser } from '../../api';

const useStyles = createStyles((theme) => ({
	preferencesTitle: {
		marginBottom: theme.spacing.md,
	},
}));

enum InterfaceTheme {
	SYSTEM_PREFERENCE = 'system',
	LIGHT = 'light',
	DARK = 'dark',
}

interface ThemeOption {
	label: string;
	value: InterfaceTheme;
}

const themeOptions: ThemeOption[] = [
	{ label: 'System preference', value: InterfaceTheme.SYSTEM_PREFERENCE },
	{ label: 'Light', value: InterfaceTheme.LIGHT },
	{ label: 'Dark', value: InterfaceTheme.DARK },
];

export function Preferences() {
	const { classes } = useStyles();
	const { user } = useAuthUser();

	const { mutateAsync: updateUser } = useUpdateUser({});

	const handleThemeChange = useCallback(
		(selectedTheme: string | null): void => {
			updateUser({
				data: {
					id: user.id,
					user_appearance: selectedTheme as InterfaceTheme,
				},
			});
		},
		[user, updateUser]
	);

	return (
		<>
			<Title className={classes.preferencesTitle} size="md">
				Appearance
			</Title>
			<Box>
				<SettingsSelect
					title="Interface theme"
					description="Select your interface theme"
					options={themeOptions}
					onChange={handleThemeChange}
					searchable={false}
					value={user?.user_appearance || InterfaceTheme.SYSTEM_PREFERENCE}
				/>
			</Box>
		</>
	);
}
